<template>
  <div id="app">
    <div class="body_bg">
      <div class="container pd15 whitebg">
        <el-row :gutter="25">
            <DocumentsNewsBlockControl />
          <el-col
            :xs="24"
            :sm="24"
            :md="19"
            :lg="19"
            :xl="19"
            class="rightfloat"
          >
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style="margin-bottom: 0">
                  <div class="title_left">
                    {{ this.id == -1 ? '最新一期' : YearIssue_No }}
                  </div>
                  <el-button-group style="margin-left: 5px">
                    <el-button
                      v-show="last != 0"
                      class="btn_list"
                      type="primary"
                      icon="el-icon-arrow-left"
                      size="small"
                      @click="lastLssue(last)"
                      >上一期</el-button
                    >
                    <el-button
                      class="btn_list"
                      v-show="next != 0"
                      type="primary"
                      size="small"
                      style="margin-left: 5px"
                      @click="nextLssue(next)"
                      >下一期<i class="el-icon-arrow-right el-icon--right"></i
                    ></el-button>
                  </el-button-group>
                  <div class="title_more2">
                    <a href="/">首页</a>>{{
                      this.id == -1 ? '最新一期' : titles
                    }}
                  </div>
                  <div class="clearfix"></div>
                </div>
                <div class="side_container">
                  <div class="dqml">
                    <IssueArticleListControl
                      :newListTitle="newListTitle"
                      :CloumnList="CloumnList"
                      :List="newList"
                      :Periods="Periods"
                      :isOA="false"
                      :type="0"
                      :id="id == -1 ? 1 : 0 || id == 1 ? 2 : 0"
                      v-loading="loading"
                      :isdataa="true"
                    ></IssueArticleListControl>
                    <common-page
                      :count="count"
                      @pageSize="pageSize"
                      @pageindex="pageindex"
                      :index="paramas"
                    ></common-page>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import IssueArticleListControl from '../components/IssueArticleListControl/IssueArticleListControl'
export default {
  data() {
    return {
      keywords: '',
      activeName: 'first',
      data: {},
      newList: [],
      List: [],
      Lista: [],
      newListTitle: '',
      CoverGUID: false,
      BackCoverGUID: false,
      TableConGUID: false,
      Rss: false,
      loading: true,
      cotype: '',
      Periods: {},
      FileGUID: '',
      count: 0,
      last: '',
      next: '',
      titles: '',
      isyuchuban: false,
      YearIssue_No: '',
      id: 0,
      type: '',
      CloumnList: [],
      paramas: {
        PageSize: 10,
        PageIndex: 0,
        IssueId: 0,
      },
      paramsa: {
        PageSize: 10,
        PageIndex: 0,
        Type: '',
        Key: '',
        src: '',
      },
    }
  },
  components: {
    IssueArticleListControl,
  },
  created() {
    this.id = this.$route.query.IssueId
    if (this.id == -1) {
      document.title = '最新一期'
    } else if (this.id == 1) {
      document.title = '当期目录'
    } else {
    }
    this.type = this.$route.query.type
    this.GetIssue()
    this.getArticList()
  },
  watch: {
    $route(to, from) {
      if (to.query.IssueId !== from.query.IssueId) {
        this.id = to.query.IssueId
        if (this.id) {
          this.GetIssue()
          this.CloumnList = []
          this.getArticList()
        }
      }
    },
  },
  methods: {
    lastLssue(id) {
      this.$router.push({
        path: '/OAList',
        query: { refreshCache: true,IssueId:id },
      })
    },
    nextLssue(id) {
      this.$router.push({
        path: '/OAList',
           query: { refreshCache: true,IssueId:id },
      })
    },
    GetIssue() {
      this.$store
        .dispatch('_getYear', { Id: this.id })
        .then((res) => {
          this.next = res.data.Data.DownIssue
          this.last = res.data.Data.UpIssue
          this.newListTitle = res.data.Data.YearIssue_NoTtitle
          this.YearIssue_No = res.data.Data.YearIssue_No
          this.Periods = res.data.Data
          this.titles = '当期目录'
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getArticList(PageSize, PageIndex, IssueId) {
      this.paramas = {
        PageSize: PageSize ? PageSize : 10,
        PageIndex: PageIndex ? PageIndex : this.paramas.PageIndex,
        IssueId: this.id,
      }
      this.$store
        .dispatch('_getNewlist', this.paramas)
        .then((res) => {
          this.loading = false
          this.newList = res.data.Data
          this.List = res.data.Data
          this.count = res.data.ItemCount
          this.List.map((item) => {
            if (item.Column) {
              this.CloumnList.push(item)
            }
          })
        })
        .catch((err) => {
          console.log(err)
        })
    },
    _getListb(pageSize, PageIndex) {
      var time = new Date().getTime()
      this.paramsa = {
        PageSize: pageSize ? pageSize : 10,
        PageIndex: PageIndex ? PageIndex : this.paramsa.PageIndex,
        Type: this.type,
        Key: this.id,
        src: time,
      }
      this.$store
        .dispatch('_getListb', this.paramsa)
        .then((res) => {
          if (res.data.IsSuccess) {
            this.loading = false
            this.newList = res.data.Data
            this.count = res.data.ItemCount
            this.YearIssue_No = res.data.Title
            this.titles = res.data.Title
          }
        })
        .catch((err) => {
          console.log(err, 'err')
        })
    },
    pageSize(val) {
      this.CloumnList = []
      this.getArticList(val, this.paramsa.PageIndex, this.id)
    },
    pageindex(val) {
      this.CloumnList = []
      this.getArticList(this.paramas.PageSize, val, this.id)
    },
  },
}
</script>

<style scoped>
.btn_list {
  background-color: #fff !important;
  border-color: #fff;
  border: none !important;
  color: #0748ad;
  font-size: 16px;
}
.btn_list:hover {
  background: #215bc7 !important;
}
</style>
